import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Modal, ScrollView, TouchableOpacity, View } from "react-native-web";

import DoorHandling from "../../components/Users/DoorHandling";
import { IDNumberGenerator } from "../../customFunction/IDGenerator";
import { editCurrentUser } from "../../store/actions/usersAction";
import Colors from "../../constant/Colors";
import { PackageCard } from "./SelectPackageScreen";
import { t } from "i18next";
import ShowPaginationData, { fetcher } from "../../components/UI/TableView/ShowPaginationData";
import { IoAdd } from "react-icons/io5";
import useSWR from "swr";
import { BsCollection } from "react-icons/bs";
import { RiDoorOpenLine } from "react-icons/ri";

function UsersScreen() {
  const currentCenterId = JSON.parse(localStorage.getItem('centerId')).centerId
  const [toggleUserModal, setToggleUserModal] = useState(false);
  const [toggleDoors, setToggleDoors] = useState(false);

  const { columns, id, label, url, href } = {
    id: 'users', label: 'users',
    href: '/users',
    columns: [{ label: '#', value: a => a.bioStarID },
    { label: 'name', sort: 'name', classnames: () => 'font-[Montserrat]', value: (a) => a.name },
    { label: 'phoneNumber', sort: 'phone', value: (a) => a.phone },
    { label: 'startDate', sort: 'start_datetime', value: (a) => dayjs(a.start_datetime).format('YYYY-MM-DD HH:mm') },
    { label: 'endDate', sort: 'expiry_datetime', value: (a) => dayjs(a.expiry_datetime).format('YYYY-MM-DD HH:mm') }],
    url: (centerId) => '/users?' + centerId,
  }
  // const ref = useRef(false);
  const history = useHistory();

  const onPressCreateUser = (_id) => {
    let now = dayjs().format("HH");

    // if (now < 6 || now >= 23) {
    //   smalltalk.alert('', 'This system is available for add user from 6 am to 11 pm');
    //   return;
    // }

    const newUser = {
      name: "",
      phone: "",
      access_groups: [],
      user_group_id: {
        id: "1",
      },
      start_datetime: dayjs().utc(true).hour('00').minute('10').format(),
      expiry_datetime: "",
      disabled: false,
      bioStarID: IDNumberGenerator(9),
      centerId: currentCenterId,
    };

    editCurrentUser(newUser);
    setTimeout(() => {
      history.push(`/users/create`);
    }, 50);
  };

  const onPressItem = (val) => {
    // console.log(val)
    let end = dayjs(val.expiry_datetime).utc();
    let start = dayjs().utc();

    // //Difference in number of days
    let dayNum = dayjs.duration(start.diff(end)).asDays() * -1;

    // if (dayNum > 0) {
    //   return;
    // }
    if (dayNum < 0) {
      val.start_datetime = dayjs().utc().hour('00').minute('10').format()
    }

    editCurrentUser(val);
    setTimeout(() => {
      history.push(dayNum > 0 ? `${window.location.pathname}/update` : `${window.location.pathname}/create`);
      // history.push(`${window.location.pathname}/create`);
    }, 50);
  };
  const toggleUserModalHandler = () => {
    setToggleUserModal(!toggleUserModal);
  };
  const toggleDoorsModalHandler = () => {
    setToggleDoors(!toggleDoors);
  };
  return (
    <div className="flex flex-col items-center w-full bg-white">
      <Modal visible={toggleUserModal} transparent>
        <MembershipsCollection toggleUserModalHandler={toggleUserModalHandler} />
      </Modal>
      <Modal visible={toggleDoors} transparent>
        <DoorHandling toggleDoorsModalHandler={toggleDoorsModalHandler} />
      </Modal>
      <div className='flex flex-1 w-full h-full mt-10' >
        <ShowPaginationData defaultSort={[{ sort: 'expiry_datetime', sortBy: 1 }]} hrefId={null} onClickItem={(_id) => onPressItem(_id)} rightButton={<div className="cursor-pointer" >
          <div className="flex items-center gap-x-3" >
            <IoAdd size={32} onClick={onPressCreateUser} />
            <BsCollection size={25} onClick={toggleUserModalHandler} />
            <RiDoorOpenLine onClick={toggleDoorsModalHandler} size={29} />
          </div>
        </div>} columns={columns} href={href} id={id} label={label} url={url} />
      </div>
    </div>
  );
}

const MembershipsCollection = ({ toggleUserModalHandler }) => {
  const currentCenterId = JSON.parse(localStorage.getItem("centerId")).centerId;
  const { data: packages, isLoading, error } = useSWR(`/packages?centerId=${currentCenterId}`, fetcher)
  const [currentPackages, setCurrentPackages] = useState(false);
  const [groupOfPackages, setGroupOfPackages] = useState(false);

  const setUpCurrentPackages = () => {
    let arr = packages;
    arr = arr.filter((a) => a.center.find((a) => a === currentCenterId) && a.price.value > 0);

    setCurrentPackages(arr);
  };

  const setUpGroupOfPackages = () => {
    let arr = [];
    let sum = -1;

    let duration = undefined;
    currentPackages.forEach((pck, i) => {
      if (duration !== pck.duration) {
        duration = pck.duration;
        arr.push({ duration, data: [] });
        sum++;
      }
      arr[sum].data.push(pck);
    });

    setGroupOfPackages(arr);
  };

  useEffect(() => {
    if (currentPackages) setUpGroupOfPackages();
  }, [currentPackages]);

  useEffect(() => {
    if (packages && packages.length > 0) setUpCurrentPackages();
  }, [currentCenterId, packages]);

  if (isLoading) return <View style={{ height: '100%', width: '100%', backgroundColor: '#fff' }} />
  return <View
    style={{
      height: "90%",
      width: "80%",
      backgroundColor: "#fff",
      alignSelf: "center",
      shadowColor: Colors.mainGreenColor,
      marginTop: 20,
      shadowOpacity: 14.5,
      shadowRadius: 20.65,
      borderRadius: 10,
      overflow: "hidden",
    }}>
    <ScrollView>
      <div className="flex flex-col flex-wrap items-center justify-center w-full p-5">
        {groupOfPackages &&
          groupOfPackages.map((gp, i) => {
            return (
              <div key={i} className="w-4/5 mb-20 ">
                <div className="flex items-center justify-center w-full p-2 text-3xl text-white bg-mainAqwaBlue ">
                  {t("days")} {gp.duration == 0 ? 1 : gp.duration}
                </div>
                <div className="flex flex-row flex-wrap justify-center p-5">
                  {gp.data &&
                    gp.data.map((dt, i) => {
                      return (
                        <PackageCard key={i} onSelectPackage={() => { }} dt={dt} />
                      );
                    })}
                </div>
              </div>
            );
          })}
      </div>
    </ScrollView>
    <CancelButton onClick={toggleUserModalHandler} />

  </View>
}

const CancelButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <TouchableOpacity
      onPress={onClick}
      activeOpacity={0.8}
      style={{
        height: 50,
        position: 'absolute',
        bottom: 0,

        width: "100%",
        backgroundColor: Colors.mainGreenColor,
        alignItems: "center",
        justifyContent: "center",
      }}>
      <h1 style={{ color: "#fff", fontSize: 20 }}>{t("cancel")}</h1>
    </TouchableOpacity>
  );
};

export default UsersScreen;
